import { render } from "./Hero.vue?vue&type=template&id=1681e8b8"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=1681e8b8&lang=css"
script.render = render

export default script